export const initConsultance = () => {

    (function ($) {
      $(document).ready(function () {     
          if(window.innerWidth <= 900) {
            $('.contactez__section').appendTo('.consultance-page-main--right');
         }  
         
         $(window).on('resize', function() {
            if (window.innerWidth <= 900) {
                    $('.contactez__section').appendTo('.consultance-page-main--right');
            }
        });
      })
    })(jQuery)
}
